import useRequest from '@/websdk/utils/request';

export default function () {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/factory/area',
    name: 'GET_FACTORY_AREA',
  });

  return [isRequestSuccessed, data || [], exec];
}
